//#region Imports
import { AnalyticsContext } from "./-private/AnalyticsContext";
//#endregion

export const AnalyticsConsumer = AnalyticsContext.Consumer;
